export default Object.freeze({
  // 공통 컬럼
  CLAIM_PROC: '클레임처리',
  CLAIM_STATUS_TYPE: '클레임상태',
  CLAIM_NO: '클레임번호',
  MALL_NAME: '쇼핑몰구분',
  ORDER_REGISTER_TYPE: '주문구분',
  RESERVED: '예약주문',
  PAYTYPE: '결제수단',
  HOLD_PROCESS: '배송보류',
  SHIPPING_AREA_TYPE: '배송구분',
  TASK_MESSAGE: '업무메세지',
  MEMBER_GROUP_INFO_JSON: '회원그룹',
  ORDER_NO: '주문번호',
  ORDERER_NAME: '주문자명',
  ORDERER_CONTACT: '주문자연락처',
  MEMBER_NO: '회원번호',
  RECEIVER_NAME: '수령자명',
  RECEIVER_CONTACT: '수령자 연락처',
  MALL_PRODUCT_NO: '상품번호',
  PRODUCT_MANAGEMENT_CD: '상품관리코드',
  PRODUCT_NAME: '상품명',
  OPTION_MANAGEMENT_CD: '옵션관리코드',
  DISPLAY_OPTION_NAME: '옵션명:옵션값',

  // 취소 관리 컬럼
  CANCEL_YMDT: '취소신청일시',
  CANCEL_COMPLETE_YMDT: '취소완료일시',
  CNT_CANCEL: '취소수량',
  CLAIM_AMT_CANCEL: '취소금액',

  // 교환 관리 컬럼
  EXCHANGE_YMDT: '교환신청일시',
  EXCHANGE_COMPLETE_YMDT: '교환완료일시',
  CNT_EXCHANGE: '교환수량',
  CLAIM_AMT_EXCHANGE: '교환금액',

  // 반품 관리 컬럼
  RETURN_YMDT: '반품신청일시',
  RETURN_COMPLETE_YMDT: '반품완료일시',
  CNT_RETURN: '반품수량',
  RETURN_WAY_TYPE: '반품수거방법',
  CLAIM_AMT_RETURN: '반품금액',

  // 환불 관리 컬럼
  REFUND_YMDT: '환불신청일시',
  REFUND_COMPLETE_YMDT: '환불완료일시',
  CNT_REFUND: '환불수량',
  CLAIM_AMT_REFUND: '환불금액',

  CNT_PRODUCT: '상품수', // 환불관리에 쓰임

  // 클레임처리 버튼
  SHOW_DETAIL: '상세보기',
  SHOW_ORDER_DETAIL: '주문상세보기',
  PROC_CANCEL: '취소승인',
  PROC_EXCHANGE: '교환승인',
  PROC_RETURN: '반품승인',
  WITHDRAW_REQUEST: '반려신청',
  EXCHANGE_WITHDRAW_REQUEST: '교환반려신청',
  RETURN_WITHDRAW_REQUEST: '반품반려신청',
  ALREADY_DELIVERY: '이미출고',
  PROC_COLLECT_COMPLETE: '수거완료처리',

  WMS_ALREADY_DELIVERY_MESSAGE: 'WMS로 자동 이미출고 처리될 예정으로 수동 처리가 불가합니다.',

  // 배송구분
  PARTNER_SHIPPING: '파트너배송',
  MALL_SHIPPING: '쇼핑몰배송',

  // 주문구분
  ORDER_REGISTER_TYPE_NORMAL: '일반주문',
  ORDER_REGISTER_TYPE_ADMIN: '수기주문',
  ORDER_REGISTER_TYPE_ARIEL: '외부연계주문',
  ORDER_REGISTER_TYPE_RECURRING_PAYMENT: '정기주문',
})